import { Certificate } from '@legacy-types';

import { useData } from '@shared/api/hooks/useData';
import { CertificatesDataTable } from '@shared/certificates/components/CertificatesDataTable';
import { getCertificates } from '@shared/certificates/endpoints/getCertificates';
import { Portlet } from '@shared/ui/components/Portlet';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';

export default function ListCertificates() {
  const certificates = useData<Certificate>({
    get: getCertificates,
    defaults: { sort: '-updated_at' },
  });

  return (
    <AdminWrapper title="Certificates">
      <Portlet>
        <CertificatesDataTable certificates={certificates} admin />
      </Portlet>
    </AdminWrapper>
  );
}
